//import * as phones from "./json/phone.json";
import { Countries } from "./country";
import { IValidationNotificator } from "../inpulse/Notificators/IValidationNotificator";

// This input needs following polyfills for some browser (ex. IE11)
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
//
// You can download polyfills from: https://cdn.polyfill.io/v3/api/
//Issues: https://stackoverflow.com/questions/3968416/ie-javascript-error-object-doesnt-support-this-property-or-method-within-jque/3969064#3969064


export class ValidationMessages {
    FILL_OUT_FIELD: string;
    PHONE_NUMBER_NOT_IN_RIGHT_INTERNATIANAL_FORMAT: string;
    PHONE_NUMBER_NOT_IN_SUPPORTED_INTERNATIANAL_FORMAT: string;
    constructor() {
        this.FILL_OUT_FIELD = "Please fill out this field.";
        this.PHONE_NUMBER_NOT_IN_RIGHT_INTERNATIANAL_FORMAT = "Puhelinnumero tulee antaa kansainvälisessä muodossa (+358401234567)";
        this.PHONE_NUMBER_NOT_IN_SUPPORTED_INTERNATIANAL_FORMAT = "Puhelinnumero ei ole tuetuissa kansainvälisissä muodoissa. Tuetut formaatit:";
    }
}

export class InternationalPhoneInputSettings {
    validationMessages: ValidationMessages;
    initOnDocumentReady: boolean;
    validateOnFocusOut: boolean;
    validateOnlyIfRequiredField: boolean;
    autofillOnFocusIn: boolean;
    constructor(initializeOnDocumentReady: boolean, messages: ValidationMessages) {

        this.validationMessages = new ValidationMessages();
        if (messages !== window['undefined'] && messages !== null) {
            this.validationMessages = messages;
        }
        this.initOnDocumentReady = false;
        if (initializeOnDocumentReady !== window['undefined'] && initializeOnDocumentReady !== null && typeof initializeOnDocumentReady === 'boolean') {
            this.initOnDocumentReady = initializeOnDocumentReady;
        }       
        this.validateOnFocusOut = true;
        this.validateOnlyIfRequiredField = false;
        this.autofillOnFocusIn = true;  
    }
}

export class InternationalPhoneInputInitializer {

    _elements: HTMLCollectionOf<Element>;
    _initialized: HTMLCollectionOf<HTMLInputElement>;
    _settings: InternationalPhoneInputSettings;
    _document: Document;

    constructor(doc: Document, settings: InternationalPhoneInputSettings)
    {
        let self = this;
        this._settings = settings;
        this._document = doc;

        if (this._settings.initOnDocumentReady) {
            doc.onreadystatechange = function (ev) {
                if (this.readyState == "complete") {
                    self.init();
                }
            }
        }
    }

    init() {
        var elements = this._document.getElementsByClassName("international-tel");
        this._elements = elements;

        for (var i = 0; i < elements.length; i++) {
            if (elements[i].nodeName === 'INPUT') {
                new InternationalPhoneInput(elements[i] as HTMLInputElement, this._settings);
            }
        }
        //is there a better way to do this?
        this._initialized = this._document.getElementsByClassName("init-international-tel") as HTMLCollectionOf<HTMLInputElement>
    }

    isNotNullOrUndefined(el: object) {
        return el !== window['undefined'] && el !== null;
    }
}
declare var window: Window;

declare interface Window {
    root: root;
    _notificator: IValidationNotificator
}

declare interface root{
    countries: Countries;
}

export class InternationalPhoneInput //extends HTMLInputElement //https://stackoverflow.com/questions/39037489/extending-htmlelement-constructor-fails-when-webpack-was-used
{

    _el: HTMLInputElement;
    _allowedPhones: string[];
    _allPhones: string[];
    _countries: Countries;
    _notificator: IValidationNotificator;
    _settings: InternationalPhoneInputSettings;

    constructor(el: HTMLInputElement, settings: InternationalPhoneInputSettings) {
        let self = this;
        this._allowedPhones = [];
        this._allPhones = [];
        this._settings = settings;
        if (!this.isNotNullOrUndefined(window.root.countries))
        {
            //It would be great to use "resolveJsonModule": true, in order to import .json-files directly.
            //Then we would not need global countries in root
            //Check ./Readme.txt for more details.
            window.root.countries = new Countries();
        }
        if (self.isNotNullOrUndefined(window._notificator)) {
            this._notificator = window._notificator;
        }

        if (this.isNotNullOrUndefined(el) && el.nodeName == 'INPUT') {
            this._el = el;

            //TODO:exlude attribute, and settings to set global allowed and excluded (local should override global)
            el.classList.add("init-international-tel");
            var allowed = el.attributes.getNamedItem("data-allowed-phones");
            if (this.isNotNullOrUndefined(allowed) && allowed.value != "" && allowed.value !== "*") {
                var allowedPhones = allowed.value.split(';');
                if (this.isNotNullOrUndefined(allowedPhones)) {

                    for (var i = 0; i < allowedPhones.length; i++) {
                        var phone = window.root.countries.phones[allowedPhones[i]];
                        if (this.isNotNullOrUndefined(phone)) {
                            if (!(phone as string).startsWith("+")) {
                                phone = "+" + phone;//not sure if we should add '+' here
                            }
                            this._allowedPhones.push(phone);
                        }
                    }
                }
                else {
                    this._allowedPhones = ["*"];
                }

            }
            else {
                this._allowedPhones = ["*"];
            }

            //Entries polyfill above
            for (let [key, value] of (<any>Object).entries(window.root.countries.phones)) {
                var p = value;
                //we don't want to add empty here 
                //add support to missing international phones: ("BV": "Bouvet Island", "GS": "South Georgia and the South Sandwich Islands", "AQ": "Antarctica", "TF": "French Southern Territories", "HM": "Heard Island and McDonald Islands"  )
                if (p !== "" && p !== " ")
                {
                    if (!(value as string).startsWith("+"))
                    {
                        p = "+" + p;//not sure if we should add '+' here
                    }
                    this._allPhones.push(p);
                }              
            }
            this.AddEvents(el);
        }
    }

    CheckElementsValidity(el: HTMLInputElement) {
        let self = this;
        self._notificator.hideValidationError(el);
        if (el.checkValidity())
        {
            if (!this._settings.validateOnlyIfRequiredField || this._settings.validateOnlyIfRequiredField == el.required)
            {
                let message = this.checkPhonenumber(el);
                if (message !== null)
                {
                    self._notificator.addValidationError(el, message);
                }
            }
        }
        else
        {
            var message = el.validationMessage;
            console.error(message);
            if (el.required && el.value == "" || el.value == null) {
                message = self._settings.validationMessages.FILL_OUT_FIELD;
            }
            self._notificator.addValidationError(el, message);//TODO: localizations for normal validation messages https://formvalidation.io/guide/getting-started <= this could be nice, but it costs
        }
    }

    AutoFill(el: HTMLInputElement) {
        if (el.value === null || el.value === '') {
            if (this._allowedPhones[0] === '*') {
                el.value = "+358";
            }
            else {
                el.value = this._allowedPhones[0]; //first allowed phone that is defined in attribute (example. data-allowed-phones="FI" => FI=358)
            }
        }
    }

    //Should we have addEvents in initializer instead?
    AddEvents(el: HTMLInputElement) {
        let self = this;

        if (this._settings.validateOnFocusOut) {
            el.addEventListener('focusout', (event) => {
                self.CheckElementsValidity(el);
            });
        }

        if (this._settings.autofillOnFocusIn)
        {
            el.addEventListener('focusin', (event) => {
                self.AutoFill(el);
            });
        }
    }

    checkPhonenumber(el: HTMLInputElement): string
    {
        var message: string = null;
        for (var i = 0; i < this._allowedPhones.length; i++)
        {
            if (this._allowedPhones[i] === "*")
            {
                //should we also check parent elements with class="form-group required"?
                if (el.required && !el.value.startsWith('+'))//We want it to at least have + defined
                {
                    message = this._settings.validationMessages.PHONE_NUMBER_NOT_IN_RIGHT_INTERNATIANAL_FORMAT;
                }
                else if (el.required)
                {
                    for (var i = 0; i < this._allPhones.length; i++) {
                        if (el.value.startsWith(this._allPhones[i]))
                        {
                            return null;
                        }
                    }
                    message = this._settings.validationMessages.PHONE_NUMBER_NOT_IN_RIGHT_INTERNATIANAL_FORMAT;
                }
                return message;
            }
            if (el.value.startsWith(this._allowedPhones[i]))
            {
                return message;
            }
        }
        if (el.value.startsWith('+'))
        {
            message = this._settings.validationMessages.PHONE_NUMBER_NOT_IN_SUPPORTED_INTERNATIANAL_FORMAT;
            message = message.concat(this._allowedPhones.join());
        }
        else
        {
            message = this._settings.validationMessages.PHONE_NUMBER_NOT_IN_RIGHT_INTERNATIANAL_FORMAT;
        }
        
        return message;
    }

    isNotNullOrUndefined(el: object) {
        return el !== window['undefined'] && el !== null;
    }
}